import { ExcelDataType, WorkSheet } from 'xlsx-js-style';

export const MAIN_FONT = 'Times New Roman';
export const CONTROLLERS_STRING = 'Контроль за работой в выходной/нерабочий праздничный день возложить на';
export const RESPONSIBLES_STRING =
  'Ответственность за организацию работ, безопасные условия труда и ведение табельного учета возложить на';

export const CONTROLLERS_STRING_OVERTIME = 'Контроль за работой сверхурочно возложить на';

export function charsIterate(start: string, end: string, callback: (letter: string) => any) {
  for (let i = start.charCodeAt(0); i <= end.charCodeAt(0); i++) {
    callback(String.fromCharCode(i));
  }
}
export const types: ExcelDataType[] = ['n', 's', 's', 's', 's', 's', 's', 'd', 's', 's', 's', 's', 's', 's', 's', 's'];
export const typesOvertime: ExcelDataType[] = ['n', 's', 's', 's', 's', 'd', 's', 's', 's'];

export function createStyleObject(number: number, style: Record<string, any>, start: string, end: string) {
  const resultObject = {};
  charsIterate(start, end, letter => {
    resultObject[letter + number] = style;
  });
  return resultObject;
}

export const innerProperties = ['!cols', '!rows', '!merges', '!protect', '!autofilter', '!margins', '!ref'];
export const innerPropertiesCopy = ['!cols', '!rows', '!ref', '!merges', '!margins'];

export const patternRvd: WorkSheet = {
  '!ref': 'A1:U40',
  'H1': {
    t: 's',
    v: 'Утверждена приказом предприятия ',
    r: '<t xml:space="preserve">Утверждена приказом предприятия </t>',
    h: 'Утверждена приказом предприятия ',
    w: 'Утверждена приказом предприятия ',
  },
  'B2': {
    t: 's',
    v: '№ приказа',
    r: '<t>№ приказа</t>',
    h: '№ приказа',
    w: '№ приказа',
  },
  'C2': {
    t: 's',
    v: 'Дата приказа',
    r: '<t>Дата приказа</t>',
    h: 'Дата приказа',
    w: 'Дата приказа',
  },
  'D2': {
    t: 's',
    v: 'ТН руководителя',
    r: '<t>ТН руководителя</t>',
    h: 'ТН руководителя',
    w: 'ТН руководителя',
  },
  'E2': {
    t: 's',
    v: 'Оценка времени',
    r: '<t>Оценка времени</t>',
    h: 'Оценка времени',
    w: 'Оценка времени',
  },
  'F2': {
    t: 's',
    v: 'Этап ',
    r: '<t xml:space="preserve">Этап </t>',
    h: 'Этап ',
    w: 'Этап ',
  },
  'G2': {
    t: 's',
    v: 'Вид заказа',
    r: '<t>Вид заказа</t>',
    h: 'Вид заказа',
    w: 'Вид заказа',
  },
  'H2': {
    t: 's',
    v: 'ФОРМА №  B-8.1',
    r: '<t>ФОРМА №  B-8.1</t>',
    h: 'ФОРМА №  B-8.1',
    w: 'ФОРМА №  B-8.1',
  },
  'M3': {
    t: 's',
    v: 'кому (должность, ФИО руководителя)',
    r: '<t>кому (должность, ФИО руководителя)</t>',
    h: 'кому (должность, ФИО руководителя)',
    w: 'кому (должность, ФИО руководителя)',
  },
  'M4': {
    t: 's',
    v: 'от ',
    r: '<t xml:space="preserve">от </t>',
    h: 'от ',
    w: 'от ',
  },
  'M6': {
    t: 's',
    v: '(должность)',
    r: '<t>(должность)</t>',
    h: '(должность)',
    w: '(должность)',
  },
  'M10': {
    t: 's',
    v: '(структурное подразделение)',
    r: '<t>(структурное подразделение)</t>',
    h: '(структурное подразделение)',
    w: '(структурное подразделение)',
  },
  'M12': {
    t: 's',
    v: '(ФИО работника полностью)',
    r: '<t>(ФИО работника полностью)</t>',
    h: '(ФИО работника полностью)',
    w: '(ФИО работника полностью)',
  },
  'A14': {
    t: 's',
    v: 'Служебная записка \r\nо  привлечении к работе в выходные и нерабочие праздничные дни\r\n',
    r: '<t xml:space="preserve">Служебная записка \r\nо  привлечении к работе в выходные и нерабочие праздничные дни\r\n</t>',
    h: 'Служебная записка &#x000d;<br/>о  привлечении к работе в выходные и нерабочие праздничные дни&#x000d;<br/>',
    w: 'Служебная записка \r\nо  привлечении к работе в выходные и нерабочие праздничные дни\r\n',
  },
  'A15': {
    t: 's',
    v: '   В связи с***',
    r: '<t xml:space="preserve">   В связи с***</t>',
    h: '   В связи с***',
    w: '   В связи с***',
  },
  'A16': {
    t: 's',
    v: 'прошу привлечь к работе в выходные и нерабочие праздничные дни следующих работников ',
    r: '<t xml:space="preserve">прошу привлечь к работе в выходные и нерабочие праздничные дни следующих работников </t>',
    h: 'прошу привлечь к работе в выходные и нерабочие праздничные дни следующих работников ',
    w: 'прошу привлечь к работе в выходные и нерабочие праздничные дни следующих работников ',
  },
  'A17': {
    t: 's',
    v: '№',
    r: '<t>№</t>',
    h: '№',
    w: '№',
  },
  'B17': {
    t: 's',
    v: 'Табельный номер',
    r: '<t>Табельный номер</t>',
    h: 'Табельный номер',
    w: 'Табельный номер',
  },
  'C17': {
    t: 's',
    v: 'ФИО полностью',
    r: '<t>ФИО полностью</t>',
    h: 'ФИО полностью',
    w: 'ФИО полностью',
  },
  'D17': {
    t: 's',
    v: 'Наименование (цифровой индекс)  подразделения',
    r: '<t>Наименование (цифровой индекс)  подразделения</t>',
    h: 'Наименование (цифровой индекс)  подразделения',
    w: 'Наименование (цифровой индекс)  подразделения',
  },
  'E17': {
    t: 's',
    v: 'Должность/ профессия',
    r: '<t>Должность/ профессия</t>',
    h: 'Должность/ профессия',
    w: 'Должность/ профессия',
  },
  'F17': {
    t: 's',
    v: 'Работа в выходной день в командировке (да)**',
    r: '<t>Работа в выходной день в командировке (да)**</t>',
    h: 'Работа в выходной день в командировке (да)**',
    w: 'Работа в выходной день в командировке (да)**',
  },
  'G17': {
    t: 's',
    v: 'Вид присут-ствия (0080, 0081;0090; для SAP)',
    r: '<t>Вид присут-ствия (0080, 0081;0090; для SAP)</t>',
    h: 'Вид присут-ствия (0080, 0081;0090; для SAP)',
    w: 'Вид присут-ствия (0080, 0081;0090; для SAP)',
  },
  'H17': {
    t: 's',
    v: 'Дата работы в выходной /нерабочий праздничный день',
    r: '<t>Дата работы в выходной /нерабочий праздничный день</t>',
    h: 'Дата работы в выходной /нерабочий праздничный день',
    w: 'Дата работы в выходной /нерабочий праздничный день',
  },
  'I17': {
    t: 's',
    v: 'Время работы',
    r: '<t>Время работы</t>',
    h: 'Время работы',
    w: 'Время работы',
  },
  'K17': {
    t: 's',
    v: 'Перерыв 1',
    r: '<t>Перерыв 1</t>',
    h: 'Перерыв 1',
    w: 'Перерыв 1',
  },
  'M17': {
    t: 's',
    v: 'Перерыв2**',
    r: '<t>Перерыв2**</t>',
    h: 'Перерыв2**',
    w: 'Перерыв2**',
  },
  'O17': {
    t: 's',
    v: 'Вид компенсации (двойная оплата, одинарная оплата + день отдыха)',
    r: '<t>Вид компенсации (двойная оплата, одинарная оплата + день отдыха)</t>',
    h: 'Вид компенсации (двойная оплата, одинарная оплата + день отдыха)',
    w: 'Вид компенсации (двойная оплата, одинарная оплата + день отдыха)',
  },
  'P17': {
    t: 's',
    v: 'Вид анализа смены* (вечернее время, вечерняя смена, ночная смена)',
    r: '<t>Вид анализа смены* (вечернее время, вечерняя смена, ночная смена)</t>',
    h: 'Вид анализа смены* (вечернее время, вечерняя смена, ночная смена)',
    w: 'Вид анализа смены* (вечернее время, вечерняя смена, ночная смена)',
  },
  'Q17': {
    t: 's',
    v: 'Дата планируемого дня отдыха за РВД (если дата определена)',
    r: '<t>Дата планируемого дня отдыха за РВД (если дата определена)</t>',
    h: 'Дата планируемого дня отдыха за РВД (если дата определена)',
    w: 'Дата планируемого дня отдыха за РВД (если дата определена)',
  },
  'R17': {
    t: 's',
    v: 'МВЗ**',
    r: '<t>МВЗ**</t>',
    h: 'МВЗ**',
    w: 'МВЗ**',
  },
  'S17': {
    t: 's',
    v: 'Заказ**',
    r: '<t>Заказ**</t>',
    h: 'Заказ**',
    w: 'Заказ**',
  },
  'T17': {
    t: 's',
    v: 'СПП-элемент**',
    r: '<t>СПП-элемент**</t>',
    h: 'СПП-элемент**',
    w: 'СПП-элемент**',
  },
  'U17': {
    t: 's',
    v: 'Согласие работника (подпись, дата)',
    r: '<t>Согласие работника (подпись, дата)</t>',
    h: 'Согласие работника (подпись, дата)',
    w: 'Согласие работника (подпись, дата)',
  },
  'I18': {
    t: 's',
    v: 'с',
    r: '<t>с</t>',
    h: 'с',
    w: 'с',
  },
  'J18': {
    t: 's',
    v: 'по',
    r: '<t>по</t>',
    h: 'по',
    w: 'по',
  },
  'K18': {
    t: 's',
    v: 'с',
    r: '<t>с</t>',
    h: 'с',
    w: 'с',
  },
  'L18': {
    t: 's',
    v: 'по',
    r: '<t>по</t>',
    h: 'по',
    w: 'по',
  },
  'M18': {
    t: 's',
    v: 'с',
    r: '<t>с</t>',
    h: 'с',
    w: 'с',
  },
  'N18': {
    t: 's',
    v: 'по',
    r: '<t>по</t>',
    h: 'по',
    w: 'по',
  },
  'A19': {
    v: '',
  },
  'A22': {
    t: 's',
    v: 'Контроль за работой в выходной/нерабочий праздничный день возложить на  :',
    r: '<t>Контроль за работой в выходной/нерабочий праздничный день возложить на  :</t>',
    h: 'Контроль за работой в выходной/нерабочий праздничный день возложить на  :',
    w: 'Контроль за работой в выходной/нерабочий праздничный день возложить на  :',
  },
  'H23': {
    t: 's',
    v: 'Табельный номер',
    r: '<t>Табельный номер</t>',
    h: 'Табельный номер',
    w: 'Табельный номер',
  },
  'I23': {
    t: 's',
    v: 'ФИО',
    r: '<t>ФИО</t>',
    h: 'ФИО',
    w: 'ФИО',
  },
  'M23': {
    t: 's',
    v: 'Должность',
    r: '<t>Должность</t>',
    h: 'Должность',
    w: 'Должность',
  },
  'Q23': {
    t: 's',
    v: 'Структурное подразделенеие',
    r: '<t>Структурное подразделенеие</t>',
    h: 'Структурное подразделенеие',
    w: 'Структурное подразделенеие',
  },
  'A25': {
    t: 's',
    v: 'Ответственность за организацию работ, безопасные условия труда и ведение табельного учета возложить на :',
    r: '<t>Ответственность за организацию работ, безопасные условия труда и ведение табельного учета возложить на :</t>',
    h: 'Ответственность за организацию работ, безопасные условия труда и ведение табельного учета возложить на :',
    w: 'Ответственность за организацию работ, безопасные условия труда и ведение табельного учета возложить на :',
  },
  'H26': {
    t: 's',
    v: 'Табельный номер',
    r: '<t>Табельный номер</t>',
    h: 'Табельный номер',
    w: 'Табельный номер',
  },
  'I26': {
    t: 's',
    v: 'ФИО',
    r: '<t>ФИО</t>',
    h: 'ФИО',
    w: 'ФИО',
  },
  'M26': {
    t: 's',
    v: 'Должность',
    r: '<t>Должность</t>',
    h: 'Должность',
    w: 'Должность',
  },
  'Q26': {
    t: 's',
    v: 'Структурное подразделенеие',
    r: '<t>Структурное подразделенеие</t>',
    h: 'Структурное подразделенеие',
    w: 'Структурное подразделенеие',
  },
  'L28': {
    t: 's',
    v: 'Латышев М.В.',
    r: '<t>Латышев М.В.</t>',
    h: 'Латышев М.В.',
    w: 'Латышев М.В.',
  },
  'G29': {
    t: 's',
    v: '(дата)',
    r: '<t>(дата)</t>',
    h: '(дата)',
    w: '(дата)',
  },
  'I29': {
    t: 's',
    v: '(подпись)',
    r: '<t>(подпись)</t>',
    h: '(подпись)',
    w: '(подпись)',
  },
  'L29': {
    t: 's',
    v: '(фамилия, инициалы)',
    r: '<t>(фамилия, инициалы)</t>',
    h: '(фамилия, инициалы)',
    w: '(фамилия, инициалы)',
  },
  'A31': {
    t: 's',
    v: 'Мнение выборного органа первичной профсоюзной организации',
    r: '<t>Мнение выборного органа первичной профсоюзной организации</t>',
    h: 'Мнение выборного органа первичной профсоюзной организации',
    w: 'Мнение выборного органа первичной профсоюзной организации',
  },
  'A34': {
    t: 's',
    v: 'Визы',
    r: '<t>Визы</t>',
    h: 'Визы',
    w: 'Визы',
  },
  'B35': {
    t: 's',
    v: 'Заместитель директора проекта по сооружению АЭС "Руппур" по персоналу',
    r: '<t>Заместитель директора проекта по сооружению АЭС "Руппур" по персоналу</t>',
    h: 'Заместитель директора проекта по сооружению АЭС &quot;Руппур&quot; по персоналу',
    w: 'Заместитель директора проекта по сооружению АЭС "Руппур" по персоналу',
  },
  'G35': {
    t: 's',
    v: 'Мохов Г.В.',
    r: '<t>Мохов Г.В.</t>',
    h: 'Мохов Г.В.',
    w: 'Мохов Г.В.',
  },
  'B36': {
    t: 's',
    v: '(должность)',
    r: '<t>(должность)</t>',
    h: '(должность)',
    w: '(должность)',
  },
  'F36': {
    t: 's',
    v: '(подпись)',
    r: '<t>(подпись)</t>',
    h: '(подпись)',
    w: '(подпись)',
  },
  'G36': {
    t: 's',
    v: '(ФИО)',
    r: '<t>(ФИО)</t>',
    h: '(ФИО)',
    w: '(ФИО)',
  },
  'B37': {
    t: 's',
    v: 'Начальник подразделениеа пропускного и внутреннего режимов',
    r: '<t>Начальник подразделениеа пропускного и внутреннего режимов</t>',
    h: 'Начальник подразделениеа пропускного и внутреннего режимов',
    w: 'Начальник подразделениеа пропускного и внутреннего режимов',
  },
  'G37': {
    t: 's',
    v: 'Окунев Г.С.',
    r: '<t>Окунев Г.С.</t>',
    h: 'Окунев Г.С.',
    w: 'Окунев Г.С.',
  },
  'B38': {
    t: 's',
    v: '(должность)',
    r: '<t>(должность)</t>',
    h: '(должность)',
    w: '(должность)',
  },
  'F38': {
    t: 's',
    v: '(подпись)',
    r: '<t>(подпись)</t>',
    h: '(подпись)',
    w: '(подпись)',
  },
  'G38': {
    t: 's',
    v: '(ФИО)',
    r: '<t>(ФИО)</t>',
    h: '(ФИО)',
    w: '(ФИО)',
  },
  'B40': {
    t: 's',
    v: '(должность)',
    r: '<t>(должность)</t>',
    h: '(должность)',
    w: '(должность)',
  },
  'F40': {
    t: 's',
    v: '(подпись)',
    r: '<t>(подпись)</t>',
    h: '(подпись)',
    w: '(подпись)',
  },
  'G40': {
    t: 's',
    v: '(ФИО)',
    r: '<t>(ФИО)</t>',
    h: '(ФИО)',
    w: '(ФИО)',
  },
  'B3': {
    v: '',
  },
  'C3': {
    v: '',
  },
  'D3': {
    v: '',
  },
  'E3': {
    v: '',
  },
  'F3': {
    v: '',
  },
  'G3': {
    v: '',
  },
  'M2': {
    v: '',
  },
  'N2': {
    v: '',
  },
  'O2': {
    v: '',
  },
  'P2': {
    v: '',
  },
  'Q2': {
    v: '',
  },
  'R2': {
    v: '',
  },
  'S2': {
    v: '',
  },
  'N4': {
    v: '',
  },
  'O4': {
    v: '',
  },
  'P4': {
    v: '',
  },
  'Q4': {
    v: '',
  },
  'R4': {
    v: '',
  },
  'S4': {
    v: '',
  },
  'M5': {
    v: '',
  },
  'N5': {
    v: '',
  },
  'O5': {
    v: '',
  },
  'P5': {
    v: '',
  },
  'Q5': {
    v: '',
  },
  'R5': {
    v: '',
  },
  'S5': {
    v: '',
  },
  'M7': {
    v: '',
  },
  'N7': {
    v: '',
  },
  'O7': {
    v: '',
  },
  'P7': {
    v: '',
  },
  'Q7': {
    v: '',
  },
  'R7': {
    v: '',
  },
  'S7': {
    v: '',
  },
  'M8': {
    v: '',
  },
  'N8': {
    v: '',
  },
  'O8': {
    v: '',
  },
  'P8': {
    v: '',
  },
  'Q8': {
    v: '',
  },
  'R8': {
    v: '',
  },
  'S8': {
    v: '',
  },
  'M9': {
    v: '',
  },
  'N9': {
    v: '',
  },
  'O9': {
    v: '',
  },
  'P9': {
    v: '',
  },
  'Q9': {
    v: '',
  },
  'R9': {
    v: '',
  },
  'S9': {
    v: '',
  },
  'M11': {
    v: '',
  },
  'N11': {
    v: '',
  },
  'O11': {
    v: '',
  },
  'P11': {
    v: '',
  },
  'Q11': {
    v: '',
  },
  'R11': {
    v: '',
  },
  'S11': {
    v: '',
  },
  '!autofilter': {
    ref: 'A18:AA19',
  },
  'C15': {
    v: '',
  },
  'N17': {
    v: '',
  },
  'J17': {
    v: '',
  },
  'L17': {
    v: '',
  },
  'A18': {
    v: '',
  },
  'B18': {
    v: '',
  },
  'C18': {
    v: '',
  },
  'D18': {
    v: '',
  },
  'E18': {
    v: '',
  },
  'F18': {
    v: '',
  },
  'G18': {
    v: '',
  },
  'H18': {
    v: '',
  },
  'O18': {
    v: '',
  },
  'P18': {
    v: '',
  },
  'Q18': {
    v: '',
  },
  'R18': {
    v: '',
  },
  'S18': {
    v: '',
  },
  'T18': {
    v: '',
  },
  'U18': {
    v: '',
  },
  '!margins': {
    left: 0.7,
    right: 0.7,
    top: 0.75,
    bottom: 0.75,
    header: 0.3,
    footer: 0.3,
  },
  '!merges': [
    {
      s: {
        c: 1,
        r: 31,
      },
      e: {
        c: 7,
        r: 31,
      },
    },
    {
      s: {
        c: 0,
        r: 30,
      },
      e: {
        c: 6,
        r: 30,
      },
    },
    {
      s: {
        c: 3,
        r: 16,
      },
      e: {
        c: 3,
        r: 17,
      },
    },
    {
      s: {
        c: 4,
        r: 16,
      },
      e: {
        c: 4,
        r: 17,
      },
    },
    {
      s: {
        c: 2,
        r: 16,
      },
      e: {
        c: 2,
        r: 17,
      },
    },
    {
      s: {
        c: 0,
        r: 16,
      },
      e: {
        c: 0,
        r: 17,
      },
    },
    {
      s: {
        c: 6,
        r: 28,
      },
      e: {
        c: 7,
        r: 28,
      },
    },
    {
      s: {
        c: 12,
        r: 16,
      },
      e: {
        c: 13,
        r: 16,
      },
    },

    {
      s: {
        c: 10,
        r: 16,
      },
      e: {
        c: 11,
        r: 16,
      },
    },
    {
      s: {
        c: 8,
        r: 21,
      },
      e: {
        c: 11,
        r: 21,
      },
    },
    {
      s: {
        c: 12,
        r: 21,
      },
      e: {
        c: 15,
        r: 21,
      },
    },
    {
      s: {
        c: 0,
        r: 21,
      },
      e: {
        c: 6,
        r: 22,
      },
    },
    {
      s: {
        c: 6,
        r: 37,
      },
      e: {
        c: 8,
        r: 37,
      },
    },
    {
      s: {
        c: 6,
        r: 36,
      },
      e: {
        c: 8,
        r: 36,
      },
    },
    {
      s: {
        c: 6,
        r: 39,
      },
      e: {
        c: 8,
        r: 39,
      },
    },
    {
      s: {
        c: 6,
        r: 38,
      },
      e: {
        c: 8,
        r: 38,
      },
    },
    {
      s: {
        c: 0,
        r: 33,
      },
      e: {
        c: 1,
        r: 33,
      },
    },
    {
      s: {
        c: 1,
        r: 37,
      },
      e: {
        c: 4,
        r: 37,
      },
    },
    {
      s: {
        c: 1,
        r: 36,
      },
      e: {
        c: 4,
        r: 36,
      },
    },
    {
      s: {
        c: 1,
        r: 39,
      },
      e: {
        c: 4,
        r: 39,
      },
    },
    {
      s: {
        c: 6,
        r: 34,
      },
      e: {
        c: 8,
        r: 34,
      },
    },
    {
      s: {
        c: 6,
        r: 35,
      },
      e: {
        c: 8,
        r: 35,
      },
    },
    {
      s: {
        c: 1,
        r: 34,
      },
      e: {
        c: 4,
        r: 34,
      },
    },
    {
      s: {
        c: 1,
        r: 35,
      },
      e: {
        c: 4,
        r: 35,
      },
    },
    {
      s: {
        c: 0,
        r: 11,
      },
      e: {
        c: 3,
        r: 11,
      },
    },
    {
      s: {
        c: 12,
        r: 5,
      },
      e: {
        c: 18,
        r: 5,
      },
    },
    {
      s: {
        c: 12,
        r: 6,
      },
      e: {
        c: 18,
        r: 6,
      },
    },
    {
      s: {
        c: 12,
        r: 7,
      },
      e: {
        c: 18,
        r: 7,
      },
    },
    {
      s: {
        c: 12,
        r: 8,
      },
      e: {
        c: 18,
        r: 8,
      },
    },
    {
      s: {
        c: 12,
        r: 9,
      },
      e: {
        c: 18,
        r: 9,
      },
    },
    {
      s: {
        c: 12,
        r: 10,
      },
      e: {
        c: 18,
        r: 10,
      },
    },
    {
      s: {
        c: 12,
        r: 11,
      },
      e: {
        c: 18,
        r: 11,
      },
    },
    {
      s: {
        c: 2,
        r: 14,
      },
      e: {
        c: 20,
        r: 14,
      },
    },
    {
      s: {
        c: 20,
        r: 16,
      },
      e: {
        c: 20,
        r: 17,
      },
    },
    {
      s: {
        c: 7,
        r: 16,
      },
      e: {
        c: 7,
        r: 17,
      },
    },
    {
      s: {
        c: 16,
        r: 16,
      },
      e: {
        c: 16,
        r: 17,
      },
    },
    {
      s: {
        c: 18,
        r: 16,
      },
      e: {
        c: 18,
        r: 17,
      },
    },
    {
      s: {
        c: 17,
        r: 16,
      },
      e: {
        c: 17,
        r: 17,
      },
    },
    {
      s: {
        c: 15,
        r: 16,
      },
      e: {
        c: 15,
        r: 17,
      },
    },
    {
      s: {
        c: 14,
        r: 16,
      },
      e: {
        c: 14,
        r: 17,
      },
    },
    {
      s: {
        c: 8,
        r: 16,
      },
      e: {
        c: 9,
        r: 16,
      },
    },
    {
      s: {
        c: 19,
        r: 16,
      },
      e: {
        c: 19,
        r: 17,
      },
    },
    {
      s: {
        c: 12,
        r: 1,
      },
      e: {
        c: 18,
        r: 1,
      },
    },
    {
      s: {
        c: 13,
        r: 3,
      },
      e: {
        c: 18,
        r: 3,
      },
    },
    {
      s: {
        c: 1,
        r: 38,
      },
      e: {
        c: 4,
        r: 38,
      },
    },
    {
      s: {
        c: 8,
        r: 28,
      },
      e: {
        c: 10,
        r: 28,
      },
    },
    {
      s: {
        c: 8,
        r: 27,
      },
      e: {
        c: 10,
        r: 27,
      },
    },
    {
      s: {
        c: 11,
        r: 28,
      },
      e: {
        c: 12,
        r: 28,
      },
    },
    {
      s: {
        c: 11,
        r: 27,
      },
      e: {
        c: 12,
        r: 27,
      },
    },
    {
      s: {
        c: 6,
        r: 27,
      },
      e: {
        c: 7,
        r: 27,
      },
    },
    {
      s: {
        c: 12,
        r: 2,
      },
      e: {
        c: 18,
        r: 2,
      },
    },
    {
      s: {
        c: 12,
        r: 4,
      },
      e: {
        c: 18,
        r: 4,
      },
    },

    {
      s: {
        c: 0,
        r: 13,
      },
      e: {
        c: 15,
        r: 13,
      },
    },
    {
      s: {
        c: 0,
        r: 14,
      },
      e: {
        c: 1,
        r: 14,
      },
    },
    {
      s: {
        c: 6,
        r: 16,
      },
      e: {
        c: 6,
        r: 17,
      },
    },
    {
      s: {
        c: 5,
        r: 16,
      },
      e: {
        c: 5,
        r: 17,
      },
    },
    {
      s: {
        c: 1,
        r: 16,
      },
      e: {
        c: 1,
        r: 17,
      },
    },
    {
      s: {
        c: 16,
        r: 21,
      },
      e: {
        c: 20,
        r: 21,
      },
    },
    {
      s: {
        c: 0,
        r: 24,
      },
      e: {
        c: 6,
        r: 25,
      },
    },
    {
      s: {
        c: 8,
        r: 24,
      },
      e: {
        c: 11,
        r: 24,
      },
    },
    {
      s: {
        c: 12,
        r: 24,
      },
      e: {
        c: 15,
        r: 24,
      },
    },
    {
      s: {
        c: 16,
        r: 24,
      },
      e: {
        c: 20,
        r: 24,
      },
    },
    {
      s: {
        c: 8,
        r: 25,
      },
      e: {
        c: 11,
        r: 25,
      },
    },
    {
      s: {
        c: 12,
        r: 25,
      },
      e: {
        c: 15,
        r: 25,
      },
    },
    {
      s: {
        c: 16,
        r: 25,
      },
      e: {
        c: 20,
        r: 25,
      },
    },
    {
      s: {
        c: 8,
        r: 22,
      },
      e: {
        c: 11,
        r: 22,
      },
    },
    {
      s: {
        c: 12,
        r: 22,
      },
      e: {
        c: 15,
        r: 22,
      },
    },
    {
      s: {
        c: 16,
        r: 22,
      },
      e: {
        c: 20,
        r: 22,
      },
    },
  ],
};

export function createDinamicStyles(styleObject: Record<string, any>, worksheet: WorkSheet) {
  for (const cellIndex of Object.keys(styleObject)) {
    if (worksheet[cellIndex]) {
      const cell = worksheet[cellIndex];
      const newStyle = { ...styleObject[cellIndex] };
      worksheet[cellIndex] = { ...worksheet[cellIndex], s: { ...worksheet[cellIndex].s, ...newStyle } };
    } else if (!worksheet[cellIndex]) {
      worksheet[cellIndex] = { s: styleObject[cellIndex], v: '' };
    }
  }
}

// Массив со значениями № приказа, Дата приказа, ТН руководителя, Оценка времени, Этап, Вид заказа
export const TOP_DATA = {
  B2: {
    border: {
      top: { style: 'thin', color: { rgb: '000000' } },
      bottom: { style: 'thin', color: { rgb: '000000' } },
      left: { style: 'thin', color: { rgb: '000000' } },
      right: { style: 'thin', color: { rgb: '000000' } },
    },
  },
  B3: {
    border: {
      top: { style: 'thin', color: { rgb: '000000' } },
      bottom: { style: 'thin', color: { rgb: '000000' } },
      left: { style: 'thin', color: { rgb: '000000' } },
      right: { style: 'thin', color: { rgb: '000000' } },
    },
  },
  C2: {
    border: {
      top: { style: 'thin', color: { rgb: '000000' } },
      bottom: { style: 'thin', color: { rgb: '000000' } },
      left: { style: 'thin', color: { rgb: '000000' } },
      right: { style: 'thin', color: { rgb: '000000' } },
    },
  },
  C3: {
    border: {
      top: { style: 'thin', color: { rgb: '000000' } },
      bottom: { style: 'thin', color: { rgb: '000000' } },
      left: { style: 'thin', color: { rgb: '000000' } },
      right: { style: 'thin', color: { rgb: '000000' } },
    },
  },
  D2: {
    border: {
      top: { style: 'thin', color: { rgb: '000000' } },
      bottom: { style: 'thin', color: { rgb: '000000' } },
      left: { style: 'thin', color: { rgb: '000000' } },
      right: { style: 'thin', color: { rgb: '000000' } },
    },
  },
  D3: {
    border: {
      top: { style: 'thin', color: { rgb: '000000' } },
      bottom: { style: 'thin', color: { rgb: '000000' } },
      left: { style: 'thin', color: { rgb: '000000' } },
      right: { style: 'thin', color: { rgb: '000000' } },
    },
  },
  E2: {
    border: {
      top: { style: 'thin', color: { rgb: '000000' } },
      bottom: { style: 'thin', color: { rgb: '000000' } },
      left: { style: 'thin', color: { rgb: '000000' } },
      right: { style: 'thin', color: { rgb: '000000' } },
    },
  },
  E3: {
    border: {
      top: { style: 'thin', color: { rgb: '000000' } },
      bottom: { style: 'thin', color: { rgb: '000000' } },
      left: { style: 'thin', color: { rgb: '000000' } },
      right: { style: 'thin', color: { rgb: '000000' } },
    },
  },
  F2: {
    border: {
      top: { style: 'thin', color: { rgb: '000000' } },
      bottom: { style: 'thin', color: { rgb: '000000' } },
      left: { style: 'thin', color: { rgb: '000000' } },
      right: { style: 'thin', color: { rgb: '000000' } },
    },
  },
  F3: {
    border: {
      top: { style: 'thin', color: { rgb: '000000' } },
      bottom: { style: 'thin', color: { rgb: '000000' } },
      left: { style: 'thin', color: { rgb: '000000' } },
      right: { style: 'thin', color: { rgb: '000000' } },
    },
  },
  G2: {
    border: {
      top: { style: 'thin', color: { rgb: '000000' } },
      bottom: { style: 'thin', color: { rgb: '000000' } },
      left: { style: 'thin', color: { rgb: '000000' } },
      right: { style: 'thin', color: { rgb: '000000' } },
    },
  },
  G3: {
    border: {
      top: { style: 'thin', color: { rgb: '000000' } },
      bottom: { style: 'thin', color: { rgb: '000000' } },
      left: { style: 'thin', color: { rgb: '000000' } },
      right: { style: 'thin', color: { rgb: '000000' } },
    },
  },
};

// Утверждена приказом предприятия, ФОРМА №  B-8.1
export const LITTLE_TOP_DATA = {
  H1: {
    font: {
      sz: 8,
      italic: true,
      name: MAIN_FONT,
    },
    alignment: {
      horizontal: 'left',
    },
  },
  H2: {
    font: {
      sz: 8,
      italic: true,
      name: MAIN_FONT,
    },
    alignment: {
      horizontal: 'left',
    },
  },
};

export const SIGNER_AREA_UNDERLINES = {
  M2: {
    border: {
      bottom: { style: 'thin', color: { rgb: '000000' } },
    },
  },
  N2: {
    border: {
      bottom: { style: 'thin', color: { rgb: '000000' } },
    },
  },
  O2: {
    border: {
      bottom: { style: 'thin', color: { rgb: '000000' } },
    },
  },
  P2: {
    border: {
      bottom: { style: 'thin', color: { rgb: '000000' } },
    },
  },
  Q2: {
    border: {
      bottom: { style: 'thin', color: { rgb: '000000' } },
    },
  },
  R2: {
    border: {
      bottom: { style: 'thin', color: { rgb: '000000' } },
    },
  },
  S2: {
    border: {
      bottom: { style: 'thin', color: { rgb: '000000' } },
    },
  },
  M4: {
    border: {
      bottom: { style: 'thin', color: { rgb: '000000' } },
    },
  },
  N4: {
    border: {
      bottom: { style: 'thin', color: { rgb: '000000' } },
    },
  },
  O4: {
    border: {
      bottom: { style: 'thin', color: { rgb: '000000' } },
    },
  },
  P4: {
    border: {
      bottom: { style: 'thin', color: { rgb: '000000' } },
    },
  },
  Q4: {
    border: {
      bottom: { style: 'thin', color: { rgb: '000000' } },
    },
  },
  R4: {
    border: {
      bottom: { style: 'thin', color: { rgb: '000000' } },
    },
  },
  S4: {
    border: {
      bottom: { style: 'thin', color: { rgb: '000000' } },
    },
  },
  M5: {
    border: {
      bottom: { style: 'thin', color: { rgb: '000000' } },
    },
  },
  N5: {
    border: {
      bottom: { style: 'thin', color: { rgb: '000000' } },
    },
  },
  O5: {
    border: {
      bottom: { style: 'thin', color: { rgb: '000000' } },
    },
  },
  P5: {
    border: {
      bottom: { style: 'thin', color: { rgb: '000000' } },
    },
  },
  Q5: {
    border: {
      bottom: { style: 'thin', color: { rgb: '000000' } },
    },
  },
  R5: {
    border: {
      bottom: { style: 'thin', color: { rgb: '000000' } },
    },
  },
  S5: {
    border: {
      bottom: { style: 'thin', color: { rgb: '000000' } },
    },
  },
  M7: {
    border: {
      bottom: { style: 'thin', color: { rgb: '000000' } },
    },
  },
  N7: {
    border: {
      bottom: { style: 'thin', color: { rgb: '000000' } },
    },
  },
  O7: {
    border: {
      bottom: { style: 'thin', color: { rgb: '000000' } },
    },
  },
  P7: {
    border: {
      bottom: { style: 'thin', color: { rgb: '000000' } },
    },
  },
  Q7: {
    border: {
      bottom: { style: 'thin', color: { rgb: '000000' } },
    },
  },
  R7: {
    border: {
      bottom: { style: 'thin', color: { rgb: '000000' } },
    },
  },
  S7: {
    border: {
      bottom: { style: 'thin', color: { rgb: '000000' } },
    },
  },
  M8: {
    border: {
      bottom: { style: 'thin', color: { rgb: '000000' } },
    },
  },
  N8: {
    border: {
      bottom: { style: 'thin', color: { rgb: '000000' } },
    },
  },
  O8: {
    border: {
      bottom: { style: 'thin', color: { rgb: '000000' } },
    },
  },
  P8: {
    border: {
      bottom: { style: 'thin', color: { rgb: '000000' } },
    },
  },
  Q8: {
    border: {
      bottom: { style: 'thin', color: { rgb: '000000' } },
    },
  },
  R8: {
    border: {
      bottom: { style: 'thin', color: { rgb: '000000' } },
    },
  },
  S8: {
    border: {
      bottom: { style: 'thin', color: { rgb: '000000' } },
    },
  },
  M9: {
    border: {
      bottom: { style: 'thin', color: { rgb: '000000' } },
    },
  },
  N9: {
    border: {
      bottom: { style: 'thin', color: { rgb: '000000' } },
    },
  },
  O9: {
    border: {
      bottom: { style: 'thin', color: { rgb: '000000' } },
    },
  },
  P9: {
    border: {
      bottom: { style: 'thin', color: { rgb: '000000' } },
    },
  },
  Q9: {
    border: {
      bottom: { style: 'thin', color: { rgb: '000000' } },
    },
  },
  R9: {
    border: {
      bottom: { style: 'thin', color: { rgb: '000000' } },
    },
  },
  S9: {
    border: {
      bottom: { style: 'thin', color: { rgb: '000000' } },
    },
  },
  M11: {
    border: {
      bottom: { style: 'thin', color: { rgb: '000000' } },
    },
  },
  N11: {
    border: {
      bottom: { style: 'thin', color: { rgb: '000000' } },
    },
  },
  O11: {
    border: {
      bottom: { style: 'thin', color: { rgb: '000000' } },
    },
  },
  P11: {
    border: {
      bottom: { style: 'thin', color: { rgb: '000000' } },
    },
  },
  Q11: {
    border: {
      bottom: { style: 'thin', color: { rgb: '000000' } },
    },
  },
  R11: {
    border: {
      bottom: { style: 'thin', color: { rgb: '000000' } },
    },
  },
  S11: {
    border: {
      bottom: { style: 'thin', color: { rgb: '000000' } },
    },
  },
};

export const SIGNER_AREA_HINTS = {
  M3: {
    font: {
      name: MAIN_FONT,
      sz: 8,
    },
  },
  M6: {
    font: {
      name: MAIN_FONT,
      sz: 8,
    },
  },
  M10: {
    font: {
      name: MAIN_FONT,
      sz: 8,
    },
  },
  M12: {
    font: {
      name: MAIN_FONT,
      sz: 8,
    },
  },
};

export const COLOR_LINE = {
  C15: {
    fill: {
      bgColor: {
        rgb: 'EBF1DE',
      },
      fgColor: {
        rgb: 'EBF1DE',
      },
    },
  },
};

export const MAIN_TABLE_HEADERS = {
  ...createStyleObject(
    17,
    {
      border: {
        top: { style: 'thin', color: { rgb: '000000' } },
        bottom: { style: 'thin', color: { rgb: '000000' } },
        left: { style: 'thin', color: { rgb: '000000' } },
        right: { style: 'thin', color: { rgb: '000000' } },
      },
    },
    'A',
    'U',
  ),
  ...createStyleObject(
    18,
    {
      border: {
        top: { style: 'thin', color: { rgb: '000000' } },
        bottom: { style: 'thin', color: { rgb: '000000' } },
        left: { style: 'thin', color: { rgb: '000000' } },
        right: { style: 'thin', color: { rgb: '000000' } },
      },
    },
    'A',
    'U',
  ),
};

export const CONTROLLERS_RESPONSIBLES_DATA = {
  ...createStyleObject(
    20,
    {
      font: {
        name: MAIN_FONT,
        sz: 9,
      },
      border: {
        top: { style: 'thin', color: { rgb: '000000' } },
        bottom: { style: 'thin', color: { rgb: '000000' } },
        left: { style: 'thin', color: { rgb: '000000' } },
        right: { style: 'thin', color: { rgb: '000000' } },
      },
    },
    'H',
    'U',
  ),
  ...createStyleObject(
    23,
    {
      font: {
        name: MAIN_FONT,
        sz: 9,
      },
      border: {
        top: { style: 'thin', color: { rgb: '000000' } },
        bottom: { style: 'thin', color: { rgb: '000000' } },
        left: { style: 'thin', color: { rgb: '000000' } },
        right: { style: 'thin', color: { rgb: '000000' } },
      },
    },
    'H',
    'U',
  ),
};

export const patternOvertime: WorkSheet = {
  '!ref': 'A1:AB43',
  'L1': {
    t: 's',
    v: 'УТВЕРЖДЕНА\r\nприказом АО АСЭ\r\nот ________ № _________ ',
    r: '<t xml:space="preserve">УТВЕРЖДЕНА\r\nприказом АО АСЭ\r\nот ________ № _________ </t>',
    h: 'УТВЕРЖДЕНА&#x000d;<br/>приказом АО АСЭ&#x000d;<br/>от ________ № _________ ',
    w: 'УТВЕРЖДЕНА\r\nприказом АО АСЭ\r\nот ________ № _________ ',
  },
  'B2': {
    t: 's',
    v: 'Номер приказа',
    r: '<t>Номер приказа</t>',
    h: 'Номер приказа',
    w: 'Номер приказа',
  },
  'C2': {
    t: 's',
    v: 'Дата приказа',
    r: '<t>Дата приказа</t>',
    h: 'Дата приказа',
    w: 'Дата приказа',
  },
  'D2': {
    t: 's',
    v: 'ТН подписанта',
    r: '<t>ТН подписанта</t>',
    h: 'ТН подписанта',
    w: 'ТН подписанта',
  },
  'L2': {
    t: 's',
    v: 'Вх.НРБ № 8.2-01.06.2023',
    r: '<t>Вх.НРБ № 8.2-01.06.2023</t>',
    h: 'Вх.НРБ № 8.2-01.06.2023',
    w: 'Вх.НРБ № 8.2-01.06.2023',
  },
  'I4': {
    t: 's',
    v: 'кому (должность, ФИО руководителя)',
    r: '<t>кому (должность, ФИО руководителя)</t>',
    h: 'кому (должность, ФИО руководителя)',
    w: 'кому (должность, ФИО руководителя)',
  },
  'I7': {
    t: 's',
    v: '(должность)',
    r: '<t>(должность)</t>',
    h: '(должность)',
    w: '(должность)',
  },
  'I11': {
    t: 's',
    v: '(структурное подразделение)',
    r: '<t>(структурное подразделение)</t>',
    h: '(структурное подразделение)',
    w: '(структурное подразделение)',
  },
  'E13': {
    t: 's',
    v: '№',
    r: '<t>№</t>',
    h: '№',
    w: '№',
  },
  'I13': {
    t: 's',
    v: '(ФИО работника полностью)',
    r: '<t>(ФИО работника полностью)</t>',
    h: '(ФИО работника полностью)',
    w: '(ФИО работника полностью)',
  },
  'E14': {
    t: 's',
    v: 'Служебная записка \r\nо  привлечении к работе сверхурочно\r\n',
    r: '<t xml:space="preserve">Служебная записка \r\nо  привлечении к работе сверхурочно\r\n</t>',
    h: 'Служебная записка &#x000d;<br/>о  привлечении к работе сверхурочно&#x000d;<br/>',
    w: 'Служебная записка \r\nо  привлечении к работе сверхурочно\r\n',
  },
  'A15': {
    t: 's',
    v: 'В связи с',
    r: '<t>В связи с</t>',
    h: 'В связи с',
    w: 'В связи с',
  },
  'A16': {
    t: 's',
    v: 'прошу привлечь к работе сверхурочно следующих работников',
    r: '<t>прошу привлечь к работе сверхурочно следующих работников</t>',
    h: 'прошу привлечь к работе сверхурочно следующих работников',
    w: 'прошу привлечь к работе сверхурочно следующих работников',
  },
  'A17': {
    t: 's',
    v: '№ п/п',
    r: '<t>№ п/п</t>',
    h: '№ п/п',
    w: '№ п/п',
  },
  'B17': {
    t: 's',
    v: 'Табельный номер',
    r: '<t>Табельный номер</t>',
    h: 'Табельный номер',
    w: 'Табельный номер',
  },
  'C17': {
    t: 's',
    v: 'ФИО полностью',
    r: '<t>ФИО полностью</t>',
    h: 'ФИО полностью',
    w: 'ФИО полностью',
  },
  'D17': {
    t: 's',
    v: 'Наименование подразделения',
    r: '<t>Наименование подразделения</t>',
    h: 'Наименование подразделения',
    w: 'Наименование подразделения',
  },
  'E17': {
    t: 's',
    v: 'Должность/профессия',
    r: '<t>Должность/профессия</t>',
    h: 'Должность/профессия',
    w: 'Должность/профессия',
  },
  'F17': {
    t: 's',
    v: 'Дата работы сверхурочно',
    r: '<t>Дата работы сверхурочно</t>',
    h: 'Дата работы сверхурочно',
    w: 'Дата работы сверхурочно',
  },
  'G17': {
    t: 's',
    v: 'Время работы',
    r: '<t>Время работы</t>',
    h: 'Время работы',
    w: 'Время работы',
  },
  'I17': {
    t: 's',
    v: 'Вид компенсации',
    r: '<t>Вид компенсации</t>',
    h: 'Вид компенсации',
    w: 'Вид компенсации',
  },
  'J17': {
    t: 's',
    v: 'МВЗ',
    r: '<t>МВЗ</t>',
    h: 'МВЗ',
    w: 'МВЗ',
  },
  'K17': {
    t: 's',
    v: 'Заказ',
    r: '<t>Заказ</t>',
    h: 'Заказ',
    w: 'Заказ',
  },
  'L17': {
    t: 's',
    v: 'СПП-элемент',
    r: '<t>СПП-элемент</t>',
    h: 'СПП-элемент',
    w: 'СПП-элемент',
  },
  'M17': {
    t: 's',
    v: 'Согласие работника (подпись, дата)',
    r: '<t>Согласие работника (подпись, дата)</t>',
    h: 'Согласие работника (подпись, дата)',
    w: 'Согласие работника (подпись, дата)',
  },
  'G18': {
    t: 's',
    v: 'с',
    r: '<t>с</t>',
    h: 'с',
    w: 'с',
  },
  'H18': {
    t: 's',
    v: 'по',
    r: '<t>по</t>',
    h: 'по',
    w: 'по',
  },
  'A20': {
    t: 's',
    v: 'Контроль за работой сверхурочно возложить на ',
    r: '<t xml:space="preserve">Контроль за работой сверхурочно возложить на </t>',
    h: 'Контроль за работой сверхурочно возложить на ',
    w: 'Контроль за работой сверхурочно возложить на ',
  },
  'G21': {
    t: 's',
    v: 'Табельный номер',
    r: '<t>Табельный номер</t>',
    h: 'Табельный номер',
    w: 'Табельный номер',
  },
  'H21': {
    t: 's',
    v: 'ФИО',
    r: '<t>ФИО</t>',
    h: 'ФИО',
    w: 'ФИО',
  },
  'J21': {
    t: 's',
    v: 'Должность',
    r: '<t>Должность</t>',
    h: 'Должность',
    w: 'Должность',
  },
  'N21': {
    t: 's',
    v: 'Структурное подразделение работника',
    r: '<t>Структурное подразделение работника</t>',
    h: 'Структурное подразделение работника',
    w: 'Структурное подразделение работника',
  },
  'A24': {
    t: 's',
    v: 'Ответственность за организацию работ, безопасные условия труда и ведение табельного учета возложить на ',
    r: '<t xml:space="preserve">Ответственность за организацию работ, безопасные условия труда и ведение табельного учета возложить на </t>',
    h: 'Ответственность за организацию работ, безопасные условия труда и ведение табельного учета возложить на ',
    w: 'Ответственность за организацию работ, безопасные условия труда и ведение табельного учета возложить на ',
  },
  'G25': {
    t: 's',
    v: 'Табельный номер',
    r: '<t>Табельный номер</t>',
    h: 'Табельный номер',
    w: 'Табельный номер',
  },
  'H25': {
    t: 's',
    v: 'ФИО',
    r: '<t>ФИО</t>',
    h: 'ФИО',
    w: 'ФИО',
  },
  'J25': {
    t: 's',
    v: 'Должность',
    r: '<t>Должность</t>',
    h: 'Должность',
    w: 'Должность',
  },
  'N25': {
    t: 's',
    v: 'Структурное подразделение работника',
    r: '<t>Структурное подразделение работника</t>',
    h: 'Структурное подразделение работника',
    w: 'Структурное подразделение работника',
  },
  'E29': {
    t: 's',
    v: '(дата)',
    r: '<t>(дата)</t>',
    h: '(дата)',
    w: '(дата)',
  },
  'G29': {
    t: 's',
    v: '(подпись)',
    r: '<t>(подпись)</t>',
    h: '(подпись)',
    w: '(подпись)',
  },
  'H29': {
    t: 's',
    v: '(фамилия, инициалы)',
    r: '<t>(фамилия, инициалы)</t>',
    h: '(фамилия, инициалы)',
    w: '(фамилия, инициалы)',
  },
  'A31': {
    t: 's',
    v: 'Мнение выборного органа первичной профсоюзной организации',
    r: '<t>Мнение выборного органа первичной профсоюзной организации</t>',
    h: 'Мнение выборного органа первичной профсоюзной организации',
    w: 'Мнение выборного органа первичной профсоюзной организации',
  },
  'A34': {
    t: 's',
    v: 'Визы',
    r: '<t>Визы</t>',
    h: 'Визы',
    w: 'Визы',
  },
  'B36': {
    t: 's',
    v: '(должность)',
    r: '<t>(должность)</t>',
    h: '(должность)',
    w: '(должность)',
  },
  'G36': {
    t: 's',
    v: '(подпись)',
    r: '<t>(подпись)</t>',
    h: '(подпись)',
    w: '(подпись)',
  },
  'H36': {
    t: 's',
    v: '(ФИО)',
    r: '<t>(ФИО)</t>',
    h: '(ФИО)',
    w: '(ФИО)',
  },
  'B38': {
    t: 's',
    v: '(должность)',
    r: '<t>(должность)</t>',
    h: '(должность)',
    w: '(должность)',
  },
  'G38': {
    t: 's',
    v: '(подпись)',
    r: '<t>(подпись)</t>',
    h: '(подпись)',
    w: '(подпись)',
  },
  'H38': {
    t: 's',
    v: '(ФИО)',
    r: '<t>(ФИО)</t>',
    h: '(ФИО)',
    w: '(ФИО)',
  },
  'B40': {
    t: 's',
    v: '(должность)',
    r: '<t>(должность)</t>',
    h: '(должность)',
    w: '(должность)',
  },
  'G40': {
    t: 's',
    v: '(подпись)',
    r: '<t>(подпись)</t>',
    h: '(подпись)',
    w: '(подпись)',
  },
  'H40': {
    t: 's',
    v: '(ФИО)',
    r: '<t>(ФИО)</t>',
    h: '(ФИО)',
    w: '(ФИО)',
  },
  '!margins': {
    left: 0.7,
    right: 0.7,
    top: 0.75,
    bottom: 0.75,
    header: 0.3,
    footer: 0.3,
  },
  '!merges': [
    {
      s: {
        c: 13,
        r: 23,
      },
      e: {
        c: 16,
        r: 23,
      },
    },
    {
      s: {
        c: 7,
        r: 39,
      },
      e: {
        c: 8,
        r: 39,
      },
    },
    {
      s: {
        c: 7,
        r: 38,
      },
      e: {
        c: 8,
        r: 38,
      },
    },
    {
      s: {
        c: 0,
        r: 25,
      },
      e: {
        c: 16,
        r: 25,
      },
    },
    {
      s: {
        c: 0,
        r: 30,
      },
      e: {
        c: 7,
        r: 30,
      },
    },
    {
      s: {
        c: 0,
        r: 33,
      },
      e: {
        c: 1,
        r: 33,
      },
    },
    {
      s: {
        c: 1,
        r: 37,
      },
      e: {
        c: 4,
        r: 37,
      },
    },
    {
      s: {
        c: 1,
        r: 36,
      },
      e: {
        c: 4,
        r: 36,
      },
    },
    {
      s: {
        c: 1,
        r: 39,
      },
      e: {
        c: 4,
        r: 39,
      },
    },
    {
      s: {
        c: 7,
        r: 34,
      },
      e: {
        c: 8,
        r: 34,
      },
    },
    {
      s: {
        c: 7,
        r: 35,
      },
      e: {
        c: 8,
        r: 35,
      },
    },
    {
      s: {
        c: 1,
        r: 34,
      },
      e: {
        c: 4,
        r: 34,
      },
    },
    {
      s: {
        c: 1,
        r: 35,
      },
      e: {
        c: 4,
        r: 35,
      },
    },
    {
      s: {
        c: 9,
        r: 26,
      },
      e: {
        c: 16,
        r: 26,
      },
    },
    {
      s: {
        c: 7,
        r: 27,
      },
      e: {
        c: 8,
        r: 27,
      },
    },
    {
      s: {
        c: 0,
        r: 26,
      },
      e: {
        c: 7,
        r: 26,
      },
    },
    {
      s: {
        c: 7,
        r: 37,
      },
      e: {
        c: 8,
        r: 37,
      },
    },
    {
      s: {
        c: 7,
        r: 36,
      },
      e: {
        c: 8,
        r: 36,
      },
    },
    {
      s: {
        c: 1,
        r: 31,
      },
      e: {
        c: 8,
        r: 31,
      },
    },
    {
      s: {
        c: 7,
        r: 28,
      },
      e: {
        c: 8,
        r: 28,
      },
    },
    {
      s: {
        c: 8,
        r: 12,
      },
      e: {
        c: 16,
        r: 12,
      },
    },
    {
      s: {
        c: 2,
        r: 14,
      },
      e: {
        c: 16,
        r: 14,
      },
    },
    {
      s: {
        c: 3,
        r: 16,
      },
      e: {
        c: 3,
        r: 17,
      },
    },
    {
      s: {
        c: 4,
        r: 16,
      },
      e: {
        c: 4,
        r: 17,
      },
    },
    {
      s: {
        c: 12,
        r: 16,
      },
      e: {
        c: 12,
        r: 17,
      },
    },
    {
      s: {
        c: 2,
        r: 16,
      },
      e: {
        c: 2,
        r: 17,
      },
    },
    {
      s: {
        c: 0,
        r: 15,
      },
      e: {
        c: 6,
        r: 15,
      },
    },
    {
      s: {
        c: 7,
        r: 15,
      },
      e: {
        c: 16,
        r: 15,
      },
    },
    {
      s: {
        c: 8,
        r: 16,
      },
      e: {
        c: 8,
        r: 17,
      },
    },
    {
      s: {
        c: 0,
        r: 14,
      },
      e: {
        c: 1,
        r: 14,
      },
    },
    {
      s: {
        c: 0,
        r: 22,
      },
      e: {
        c: 16,
        r: 22,
      },
    },
    {
      s: {
        c: 0,
        r: 19,
      },
      e: {
        c: 5,
        r: 20,
      },
    },
    {
      s: {
        c: 0,
        r: 23,
      },
      e: {
        c: 5,
        r: 24,
      },
    },
    {
      s: {
        c: 7,
        r: 24,
      },
      e: {
        c: 8,
        r: 24,
      },
    },
    {
      s: {
        c: 9,
        r: 24,
      },
      e: {
        c: 12,
        r: 24,
      },
    },
    {
      s: {
        c: 13,
        r: 24,
      },
      e: {
        c: 16,
        r: 24,
      },
    },
    {
      s: {
        c: 8,
        r: 5,
      },
      e: {
        c: 16,
        r: 5,
      },
    },
    {
      s: {
        c: 8,
        r: 6,
      },
      e: {
        c: 16,
        r: 6,
      },
    },
    {
      s: {
        c: 4,
        r: 13,
      },
      e: {
        c: 9,
        r: 13,
      },
    },
    {
      s: {
        c: 5,
        r: 16,
      },
      e: {
        c: 5,
        r: 17,
      },
    },
    {
      s: {
        c: 6,
        r: 16,
      },
      e: {
        c: 7,
        r: 16,
      },
    },
    {
      s: {
        c: 9,
        r: 16,
      },
      e: {
        c: 9,
        r: 17,
      },
    },
    {
      s: {
        c: 8,
        r: 7,
      },
      e: {
        c: 16,
        r: 7,
      },
    },
    {
      s: {
        c: 8,
        r: 8,
      },
      e: {
        c: 16,
        r: 8,
      },
    },
    {
      s: {
        c: 8,
        r: 9,
      },
      e: {
        c: 16,
        r: 9,
      },
    },
    {
      s: {
        c: 8,
        r: 10,
      },
      e: {
        c: 16,
        r: 10,
      },
    },
    {
      s: {
        c: 8,
        r: 11,
      },
      e: {
        c: 16,
        r: 11,
      },
    },
    {
      s: {
        c: 7,
        r: 23,
      },
      e: {
        c: 8,
        r: 23,
      },
    },
    {
      s: {
        c: 9,
        r: 23,
      },
      e: {
        c: 12,
        r: 23,
      },
    },
    {
      s: {
        c: 11,
        r: 0,
      },
      e: {
        c: 12,
        r: 0,
      },
    },
    {
      s: {
        c: 1,
        r: 38,
      },
      e: {
        c: 4,
        r: 38,
      },
    },
    {
      s: {
        c: 8,
        r: 2,
      },
      e: {
        c: 16,
        r: 2,
      },
    },
    {
      s: {
        c: 0,
        r: 16,
      },
      e: {
        c: 0,
        r: 17,
      },
    },
    {
      s: {
        c: 1,
        r: 16,
      },
      e: {
        c: 1,
        r: 17,
      },
    },
    {
      s: {
        c: 7,
        r: 19,
      },
      e: {
        c: 8,
        r: 19,
      },
    },
    {
      s: {
        c: 7,
        r: 20,
      },
      e: {
        c: 8,
        r: 20,
      },
    },
    {
      s: {
        c: 9,
        r: 19,
      },
      e: {
        c: 12,
        r: 19,
      },
    },
    {
      s: {
        c: 9,
        r: 20,
      },
      e: {
        c: 12,
        r: 20,
      },
    },
    {
      s: {
        c: 0,
        r: 12,
      },
      e: {
        c: 3,
        r: 12,
      },
    },
    {
      s: {
        c: 10,
        r: 16,
      },
      e: {
        c: 10,
        r: 17,
      },
    },
    {
      s: {
        c: 11,
        r: 16,
      },
      e: {
        c: 11,
        r: 17,
      },
    },
    {
      s: {
        c: 13,
        r: 20,
      },
      e: {
        c: 16,
        r: 20,
      },
    },
    {
      s: {
        c: 13,
        r: 19,
      },
      e: {
        c: 16,
        r: 19,
      },
    },
    {
      s: {
        c: 8,
        r: 3,
      },
      e: {
        c: 16,
        r: 3,
      },
    },
    {
      s: {
        c: 8,
        r: 4,
      },
      e: {
        c: 16,
        r: 4,
      },
    },
  ],
};

// Массив со значениями № приказа, Дата приказа, ТН руководителя, Оценка времени, Этап, Вид заказа
export const TOP_DATA_OVERTIME = {
  B2: {
    border: {
      top: { style: 'thin', color: { rgb: '000000' } },
      bottom: { style: 'thin', color: { rgb: '000000' } },
      left: { style: 'thin', color: { rgb: '000000' } },
      right: { style: 'thin', color: { rgb: '000000' } },
    },
  },
  B3: {
    border: {
      top: { style: 'thin', color: { rgb: '000000' } },
      bottom: { style: 'thin', color: { rgb: '000000' } },
      left: { style: 'thin', color: { rgb: '000000' } },
      right: { style: 'thin', color: { rgb: '000000' } },
    },
  },
  C2: {
    border: {
      top: { style: 'thin', color: { rgb: '000000' } },
      bottom: { style: 'thin', color: { rgb: '000000' } },
      left: { style: 'thin', color: { rgb: '000000' } },
      right: { style: 'thin', color: { rgb: '000000' } },
    },
  },
  C3: {
    border: {
      top: { style: 'thin', color: { rgb: '000000' } },
      bottom: { style: 'thin', color: { rgb: '000000' } },
      left: { style: 'thin', color: { rgb: '000000' } },
      right: { style: 'thin', color: { rgb: '000000' } },
    },
  },
  D2: {
    border: {
      top: { style: 'thin', color: { rgb: '000000' } },
      bottom: { style: 'thin', color: { rgb: '000000' } },
      left: { style: 'thin', color: { rgb: '000000' } },
      right: { style: 'thin', color: { rgb: '000000' } },
    },
  },
  D3: {
    border: {
      top: { style: 'thin', color: { rgb: '000000' } },
      bottom: { style: 'thin', color: { rgb: '000000' } },
      left: { style: 'thin', color: { rgb: '000000' } },
      right: { style: 'thin', color: { rgb: '000000' } },
    },
  },
};

// Утверждена приказом предприятия, ФОРМА №  B-8.1
export const LITTLE_TOP_DATA_OVERTIME = {
  L1: {
    font: {
      sz: 8,
      italic: true,
      name: MAIN_FONT,
    },
    alignment: {
      horizontal: 'left',
    },
  },
  L2: {
    font: {
      sz: 8,
      italic: true,
      name: MAIN_FONT,
    },
    alignment: {
      horizontal: 'left',
    },
  },
};

export const SIGNER_AREA_UNDERLINES_OVERTIME = {
  I3: {
    border: {
      bottom: { style: 'thin', color: { rgb: '000000' } },
    },
  },
  J3: {
    border: {
      bottom: { style: 'thin', color: { rgb: '000000' } },
    },
  },
  K3: {
    border: {
      bottom: { style: 'thin', color: { rgb: '000000' } },
    },
  },
  L3: {
    border: {
      bottom: { style: 'thin', color: { rgb: '000000' } },
    },
  },
  M3: {
    border: {
      bottom: { style: 'thin', color: { rgb: '000000' } },
    },
  },
  N3: {
    border: {
      bottom: { style: 'thin', color: { rgb: '000000' } },
    },
  },
  O3: {
    border: {
      bottom: { style: 'thin', color: { rgb: '000000' } },
    },
  },
  P3: {
    border: {
      bottom: { style: 'thin', color: { rgb: '000000' } },
    },
  },
  Q3: {
    border: {
      bottom: { style: 'thin', color: { rgb: '000000' } },
    },
  },
  I4: {
    fill: {
      fgColor: {
        rgb: 'D9D9D9',
      },
    },
    border: {
      bottom: { style: 'thin', color: { rgb: '000000' } },
    },
  },
  J4: {
    fill: {
      fgColor: {
        rgb: 'D9D9D9',
      },
    },
    border: {
      bottom: { style: 'thin', color: { rgb: '000000' } },
    },
  },
  K4: {
    fill: {
      fgColor: {
        rgb: 'D9D9D9',
      },
    },
    border: {
      bottom: { style: 'thin', color: { rgb: '000000' } },
    },
  },
  L4: {
    fill: {
      fgColor: {
        rgb: 'D9D9D9',
      },
    },
    border: {
      bottom: { style: 'thin', color: { rgb: '000000' } },
    },
  },
  M4: {
    fill: {
      fgColor: {
        rgb: 'D9D9D9',
      },
    },
    border: {
      bottom: { style: 'thin', color: { rgb: '000000' } },
    },
  },
  N4: {
    fill: {
      fgColor: {
        rgb: 'D9D9D9',
      },
    },
    border: {
      bottom: { style: 'thin', color: { rgb: '000000' } },
    },
  },
  O4: {
    fill: {
      fgColor: {
        rgb: 'D9D9D9',
      },
    },
    border: {
      bottom: { style: 'thin', color: { rgb: '000000' } },
    },
  },
  P4: {
    fill: {
      fgColor: {
        rgb: 'D9D9D9',
      },
    },
    border: {
      bottom: { style: 'thin', color: { rgb: '000000' } },
    },
  },
  Q4: {
    fill: {
      fgColor: {
        rgb: 'D9D9D9',
      },
    },
    border: {
      bottom: { style: 'thin', color: { rgb: '000000' } },
    },
  },
  I5: {
    border: {
      bottom: { style: 'thin', color: { rgb: '000000' } },
    },
  },
  J5: {
    border: {
      bottom: { style: 'thin', color: { rgb: '000000' } },
    },
  },
  K5: {
    border: {
      bottom: { style: 'thin', color: { rgb: '000000' } },
    },
  },
  L5: {
    border: {
      bottom: { style: 'thin', color: { rgb: '000000' } },
    },
  },
  M5: {
    border: {
      bottom: { style: 'thin', color: { rgb: '000000' } },
    },
  },
  N5: {
    border: {
      bottom: { style: 'thin', color: { rgb: '000000' } },
    },
  },
  O5: {
    border: {
      bottom: { style: 'thin', color: { rgb: '000000' } },
    },
  },
  P5: {
    border: {
      bottom: { style: 'thin', color: { rgb: '000000' } },
    },
  },
  Q5: {
    border: {
      bottom: { style: 'thin', color: { rgb: '000000' } },
    },
  },
  I6: {
    border: {
      bottom: { style: 'thin', color: { rgb: '000000' } },
    },
  },
  J6: {
    border: {
      bottom: { style: 'thin', color: { rgb: '000000' } },
    },
  },
  K6: {
    border: {
      bottom: { style: 'thin', color: { rgb: '000000' } },
    },
  },
  L6: {
    border: {
      bottom: { style: 'thin', color: { rgb: '000000' } },
    },
  },
  M6: {
    border: {
      bottom: { style: 'thin', color: { rgb: '000000' } },
    },
  },
  N6: {
    border: {
      bottom: { style: 'thin', color: { rgb: '000000' } },
    },
  },
  O6: {
    border: {
      bottom: { style: 'thin', color: { rgb: '000000' } },
    },
  },
  P6: {
    border: {
      bottom: { style: 'thin', color: { rgb: '000000' } },
    },
  },
  Q6: {
    border: {
      bottom: { style: 'thin', color: { rgb: '000000' } },
    },
  },
  I7: {
    fill: {
      fgColor: {
        rgb: 'D9D9D9',
      },
    },
    border: {
      bottom: { style: 'thin', color: { rgb: '000000' } },
    },
  },
  J7: {
    fill: {
      fgColor: {
        rgb: 'D9D9D9',
      },
    },
    border: {
      bottom: { style: 'thin', color: { rgb: '000000' } },
    },
  },
  K7: {
    fill: {
      fgColor: {
        rgb: 'D9D9D9',
      },
    },
    border: {
      bottom: { style: 'thin', color: { rgb: '000000' } },
    },
  },
  L7: {
    fill: {
      fgColor: {
        rgb: 'D9D9D9',
      },
    },
    border: {
      bottom: { style: 'thin', color: { rgb: '000000' } },
    },
  },
  M7: {
    fill: {
      fgColor: {
        rgb: 'D9D9D9',
      },
    },
    border: {
      bottom: { style: 'thin', color: { rgb: '000000' } },
    },
  },
  N7: {
    fill: {
      fgColor: {
        rgb: 'D9D9D9',
      },
    },
    border: {
      bottom: { style: 'thin', color: { rgb: '000000' } },
    },
  },
  O7: {
    fill: {
      fgColor: {
        rgb: 'D9D9D9',
      },
    },
    border: {
      bottom: { style: 'thin', color: { rgb: '000000' } },
    },
  },
  P7: {
    fill: {
      fgColor: {
        rgb: 'D9D9D9',
      },
    },
    border: {
      bottom: { style: 'thin', color: { rgb: '000000' } },
    },
  },
  Q7: {
    fill: {
      fgColor: {
        rgb: 'D9D9D9',
      },
    },
    border: {
      bottom: { style: 'thin', color: { rgb: '000000' } },
    },
  },
  I8: {
    border: {
      bottom: { style: 'thin', color: { rgb: '000000' } },
    },
  },
  J8: {
    border: {
      bottom: { style: 'thin', color: { rgb: '000000' } },
    },
  },
  K8: {
    border: {
      bottom: { style: 'thin', color: { rgb: '000000' } },
    },
  },
  L8: {
    border: {
      bottom: { style: 'thin', color: { rgb: '000000' } },
    },
  },
  M8: {
    border: {
      bottom: { style: 'thin', color: { rgb: '000000' } },
    },
  },
  N8: {
    border: {
      bottom: { style: 'thin', color: { rgb: '000000' } },
    },
  },
  O8: {
    border: {
      bottom: { style: 'thin', color: { rgb: '000000' } },
    },
  },
  P8: {
    border: {
      bottom: { style: 'thin', color: { rgb: '000000' } },
    },
  },
  Q8: {
    border: {
      bottom: { style: 'thin', color: { rgb: '000000' } },
    },
  },
  I9: {
    border: {
      bottom: { style: 'thin', color: { rgb: '000000' } },
    },
  },
  J9: {
    border: {
      bottom: { style: 'thin', color: { rgb: '000000' } },
    },
  },
  K9: {
    border: {
      bottom: { style: 'thin', color: { rgb: '000000' } },
    },
  },
  L9: {
    border: {
      bottom: { style: 'thin', color: { rgb: '000000' } },
    },
  },
  M9: {
    border: {
      bottom: { style: 'thin', color: { rgb: '000000' } },
    },
  },
  N9: {
    border: {
      bottom: { style: 'thin', color: { rgb: '000000' } },
    },
  },
  O9: {
    border: {
      bottom: { style: 'thin', color: { rgb: '000000' } },
    },
  },
  P9: {
    border: {
      bottom: { style: 'thin', color: { rgb: '000000' } },
    },
  },
  Q9: {
    border: {
      bottom: { style: 'thin', color: { rgb: '000000' } },
    },
  },
  I10: {
    border: {
      bottom: { style: 'thin', color: { rgb: '000000' } },
    },
  },
  J10: {
    border: {
      bottom: { style: 'thin', color: { rgb: '000000' } },
    },
  },
  K10: {
    border: {
      bottom: { style: 'thin', color: { rgb: '000000' } },
    },
  },
  L10: {
    border: {
      bottom: { style: 'thin', color: { rgb: '000000' } },
    },
  },
  M10: {
    border: {
      bottom: { style: 'thin', color: { rgb: '000000' } },
    },
  },
  N10: {
    border: {
      bottom: { style: 'thin', color: { rgb: '000000' } },
    },
  },
  O10: {
    border: {
      bottom: { style: 'thin', color: { rgb: '000000' } },
    },
  },
  P10: {
    border: {
      bottom: { style: 'thin', color: { rgb: '000000' } },
    },
  },
  Q10: {
    border: {
      bottom: { style: 'thin', color: { rgb: '000000' } },
    },
  },
  I12: {
    border: {
      bottom: { style: 'thin', color: { rgb: '000000' } },
    },
  },
  J12: {
    border: {
      bottom: { style: 'thin', color: { rgb: '000000' } },
    },
  },
  K12: {
    border: {
      bottom: { style: 'thin', color: { rgb: '000000' } },
    },
  },
  L12: {
    border: {
      bottom: { style: 'thin', color: { rgb: '000000' } },
    },
  },
  M12: {
    border: {
      bottom: { style: 'thin', color: { rgb: '000000' } },
    },
  },
  N12: {
    border: {
      bottom: { style: 'thin', color: { rgb: '000000' } },
    },
  },
  O12: {
    border: {
      bottom: { style: 'thin', color: { rgb: '000000' } },
    },
  },
  P12: {
    border: {
      bottom: { style: 'thin', color: { rgb: '000000' } },
    },
  },
  Q12: {
    border: {
      bottom: { style: 'thin', color: { rgb: '000000' } },
    },
  },
  I11: {
    fill: {
      fgColor: {
        rgb: 'D9D9D9',
      },
    },
  },
  J11: {
    fill: {
      fgColor: {
        rgb: 'D9D9D9',
      },
    },
  },
  K11: {
    fill: {
      fgColor: {
        rgb: 'D9D9D9',
      },
    },
  },
  L11: {
    fill: {
      fgColor: {
        rgb: 'D9D9D9',
      },
    },
  },
  M11: {
    fill: {
      fgColor: {
        rgb: 'D9D9D9',
      },
    },
  },
  N11: {
    fill: {
      fgColor: {
        rgb: 'D9D9D9',
      },
    },
  },
  O11: {
    fill: {
      fgColor: {
        rgb: 'D9D9D9',
      },
    },
  },
  P11: {
    fill: {
      fgColor: {
        rgb: 'D9D9D9',
      },
    },
  },
  Q11: {
    fill: {
      fgColor: {
        rgb: 'D9D9D9',
      },
    },
  },
  I13: {
    fill: {
      fgColor: {
        rgb: 'D9D9D9',
      },
    },
  },
  J13: {
    fill: {
      fgColor: {
        rgb: 'D9D9D9',
      },
    },
  },
  K13: {
    fill: {
      fgColor: {
        rgb: 'D9D9D9',
      },
    },
  },
  L13: {
    fill: {
      fgColor: {
        rgb: 'D9D9D9',
      },
    },
  },
  M13: {
    fill: {
      fgColor: {
        rgb: 'D9D9D9',
      },
    },
  },
  N13: {
    fill: {
      fgColor: {
        rgb: 'D9D9D9',
      },
    },
  },
  O13: {
    fill: {
      fgColor: {
        rgb: 'D9D9D9',
      },
    },
  },
  P13: {
    fill: {
      fgColor: {
        rgb: 'D9D9D9',
      },
    },
  },
  Q13: {
    fill: {
      fgColor: {
        rgb: 'D9D9D9',
      },
    },
  },
};

export const SIGNER_AREA_HINTS_OVERTIME = {
  M3: {
    font: {
      name: MAIN_FONT,
      sz: 8,
    },
  },
  M6: {
    font: {
      name: MAIN_FONT,
      sz: 8,
    },
  },
  M10: {
    font: {
      name: MAIN_FONT,
      sz: 8,
    },
  },
  M12: {
    font: {
      name: MAIN_FONT,
      sz: 8,
    },
  },
};
export const COLOR_NUMBER_OVERTIME = {
  A13: {
    fill: {
      fgColor: {
        rgb: 'D9D9D9',
      },
    },
  },
  B13: {
    fill: {
      fgColor: {
        rgb: 'D9D9D9',
      },
    },
  },
  C13: {
    fill: {
      fgColor: {
        rgb: 'D9D9D9',
      },
    },
  },
  D13: {
    fill: {
      fgColor: {
        rgb: 'D9D9D9',
      },
    },
  },
  E13: {
    fill: {
      fgColor: {
        rgb: 'D9D9D9',
      },
    },
  },
};

export const COLOR_LINE_OVERTIME = {
  C15: {
    fill: {
      fgColor: {
        rgb: 'D9D9D9',
      },
    },
  },
};

export const MAIN_TABLE_HEADERS_OVERTIME = {
  ...createStyleObject(
    17,
    {
      fill: {
        fgColor: {
          rgb: 'D9D9D9',
        },
      },
      border: {
        top: { style: 'thin', color: { rgb: '000000' } },
        bottom: { style: 'thin', color: { rgb: '000000' } },
        left: { style: 'thin', color: { rgb: '000000' } },
        right: { style: 'thin', color: { rgb: '000000' } },
      },
    },
    'A',
    'A',
  ),
  ...createStyleObject(
    17,
    {
      border: {
        top: { style: 'thin', color: { rgb: '000000' } },
        bottom: { style: 'thin', color: { rgb: '000000' } },
        left: { style: 'thin', color: { rgb: '000000' } },
        right: { style: 'thin', color: { rgb: '000000' } },
      },
    },
    'B',
    'C',
  ),
  ...createStyleObject(
    17,
    {
      fill: {
        fgColor: {
          rgb: 'D9D9D9',
        },
      },
      border: {
        top: { style: 'thin', color: { rgb: '000000' } },
        bottom: { style: 'thin', color: { rgb: '000000' } },
        left: { style: 'thin', color: { rgb: '000000' } },
        right: { style: 'thin', color: { rgb: '000000' } },
      },
    },
    'D',
    'E',
  ),
  ...createStyleObject(
    17,
    {
      border: {
        top: { style: 'thin', color: { rgb: '000000' } },
        bottom: { style: 'thin', color: { rgb: '000000' } },
        left: { style: 'thin', color: { rgb: '000000' } },
        right: { style: 'thin', color: { rgb: '000000' } },
      },
    },
    'F',
    'I',
  ),
  ...createStyleObject(
    17,
    {
      fill: {
        fgColor: {
          rgb: 'D9D9D9',
        },
      },
      border: {
        top: { style: 'thin', color: { rgb: '000000' } },
        bottom: { style: 'thin', color: { rgb: '000000' } },
        left: { style: 'thin', color: { rgb: '000000' } },
        right: { style: 'thin', color: { rgb: '000000' } },
      },
    },
    'J',
    'M',
  ),
  ...createStyleObject(
    18,
    {
      fill: {
        fgColor: {
          rgb: 'D9D9D9',
        },
      },
      border: {
        top: { style: 'thin', color: { rgb: '000000' } },
        bottom: { style: 'thin', color: { rgb: '000000' } },
        left: { style: 'thin', color: { rgb: '000000' } },
        right: { style: 'thin', color: { rgb: '000000' } },
      },
    },
    'A',
    'A',
  ),
  ...createStyleObject(
    18,
    {
      border: {
        top: { style: 'thin', color: { rgb: '000000' } },
        bottom: { style: 'thin', color: { rgb: '000000' } },
        left: { style: 'thin', color: { rgb: '000000' } },
        right: { style: 'thin', color: { rgb: '000000' } },
      },
    },
    'B',
    'C',
  ),
  ...createStyleObject(
    18,
    {
      fill: {
        fgColor: {
          rgb: 'D9D9D9',
        },
      },
      border: {
        top: { style: 'thin', color: { rgb: '000000' } },
        bottom: { style: 'thin', color: { rgb: '000000' } },
        left: { style: 'thin', color: { rgb: '000000' } },
        right: { style: 'thin', color: { rgb: '000000' } },
      },
    },
    'D',
    'E',
  ),
  ...createStyleObject(
    18,
    {
      border: {
        top: { style: 'thin', color: { rgb: '000000' } },
        bottom: { style: 'thin', color: { rgb: '000000' } },
        left: { style: 'thin', color: { rgb: '000000' } },
        right: { style: 'thin', color: { rgb: '000000' } },
      },
    },
    'F',
    'I',
  ),
  ...createStyleObject(
    18,
    {
      fill: {
        fgColor: {
          rgb: 'D9D9D9',
        },
      },
      border: {
        top: { style: 'thin', color: { rgb: '000000' } },
        bottom: { style: 'thin', color: { rgb: '000000' } },
        left: { style: 'thin', color: { rgb: '000000' } },
        right: { style: 'thin', color: { rgb: '000000' } },
      },
    },
    'J',
    'M',
  ),
};

export const CONTROLLERS_RESPONSIBLES_DATA_OVERTIME = {
  ...createStyleObject(
    20,
    {
      font: {
        name: MAIN_FONT,
        sz: 9,
      },
      border: {
        top: { style: 'thin', color: { rgb: '000000' } },
        bottom: { style: 'thin', color: { rgb: '000000' } },
        left: { style: 'thin', color: { rgb: '000000' } },
        right: { style: 'thin', color: { rgb: '000000' } },
      },
    },
    'H',
    'U',
  ),
  ...createStyleObject(
    23,
    {
      font: {
        name: MAIN_FONT,
        sz: 9,
      },
      border: {
        top: { style: 'thin', color: { rgb: '000000' } },
        bottom: { style: 'thin', color: { rgb: '000000' } },
        left: { style: 'thin', color: { rgb: '000000' } },
        right: { style: 'thin', color: { rgb: '000000' } },
      },
    },
    'H',
    'U',
  ),
};
